import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import LoaderButton from '../../../shared/components/Button/LoaderButton';
import { FormattedMessage } from 'react-intl';

interface Props {
    modalSubmit: () => void;
    modalClosed: () => void;
    isLoading:boolean;
}

const DeletePopup: React.FC<Props> = props => {
    return (
        <Modal show={true} centered onHide={props.modalClosed} dialogClassName="delete-popup">
            <Modal.Header closeButton>
				<Modal.Title><FormattedMessage id='Application_Title' /></Modal.Title>
            </Modal.Header>
			<Modal.Body><div className="bootbox-body"><FormattedMessage id='Message_Delete_Confirm' /></div></Modal.Body>
            <Modal.Footer>
                <LoaderButton type="submit" onClick={props.modalSubmit} isLoading={props.isLoading} text="Button_Confirm"/> 
                <Button variant="primary" onClick={props.modalClosed} className="btnOkSize">
                <FormattedMessage id='Button_Cancel' />
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default DeletePopup;
